export function flipFilterSwitch() {
    return {
        type: 'FLIP_FILTER_SWITCH',
        payload: '',
    }
}

export function setDimensions(payload) {
    return {
        type: 'SET_DIMENSIONS',
        payload: payload,
    }
}

export function toggleFilterType(payload) {
    return {
        type: 'TOGGLE_FILTER_TYPE',
        payload: payload,
    }
}

export function quantityChange(payload) {
    return {
        type: 'QUANTITY_CHANGE',
        payload: payload,
    }
}

export function cartChangePage(payload) {
    return {
        type: 'CART_CHANGE_PAGE',
        payload: payload,
    }
}

export function cartChangeDeliveryInfo(payload) {
    return {
        type: 'CART_CHANGE_DELIVERY_INFO',
        payload: payload,
    }
}

export function changeCatalogPage(payload) {
    return {
        type: 'CHANGE_CATALOG_PAGE',
        payload: payload,
    }
}

export function openAddToCartModal(payload) {
    return {
        type: 'ADD_TO_CART_MODAL_OPEN',
        payload: payload,
    }
}

export function closeAddToCartModal(payload) {
    return {
        type: 'ADD_TO_CART_MODAL_CLOSE',
        payload: payload,
    }
}

export function addToCart(payload) {
    return {
        type: 'ADD_TO_CART',
        payload: payload,
    }
}

export function removeFromCart(payload) {
    return {
        type: 'REMOVE_FROM_CART',
        payload: payload,
    }
}

export function redirect(payload) {
    return {
        type: 'REDIRECT',
        payload: payload,
    }
}

export function requestProducts() {
    return {
        types: ['PRODUCTS_LOAD_PENDING', 'PRODUCTS_LOAD_SUCCESS', 'PRODUCTS_LOAD_ERROR'],
        url: '/products',
    };
}